import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 max-w-lg sm:mx-4" }
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "inline-block mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_7 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Confirm", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.modalIsOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        as: "div",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_DialogTitle, {
                      as: "h2",
                      class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, "Lock status: " + _toDisplayString(_ctx.lockStateLabel()), 1),
                        _createElementVNode("div", _hoisted_6, " Reason: " + _toDisplayString(_ctx.lockReasonName()), 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.lockStateDescription()), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_app_button, {
                      onClick: _ctx.confirmModal,
                      type: "blue",
                      class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_app_button, {
                      onClick: _ctx.closeModal,
                      type: "gray",
                      class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["show"]))
}